import { Container, Grid, Hidden, makeStyles, Paper, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import SignInForm from "./SignInForm";
import cardioLogo from "../../constants/images/logo_color_Cardio_Protecccion.png";
import LogoComponent from "./LogoComponent";
import { useLocation, useParams } from "react-router";
import { withFirebase } from "../Firebase";

const SignInPage = ({ firebase }) => {
  const classes = useStyles();
  const { token } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    !!token &&
      firebase.auth
        .sin(token)
        .then((user) => {
          console.log(user);
        })
        .catch((err) => {
          console.log(err);
        });
  }, []);

  return (
    <Grid container spacing={3} justify="center" alignItems="center" style={{ minHeight: "100vh", marginTop: 0 }}>
      <Grid container item xs={12} lg={8} xl={6}>
        <Paper className={classes.mainCard} style={{ width: "100%", borderRadius: 16, margin: 16 }}>
          <Grid item container direction="row" xs={12}>
            <Hidden smDown>
              <LogoComponent />
            </Hidden>
            <Grid
              item
              container
              xs={12}
              md={6}
              lg={6}
              justify="center"
              alignItems="center"
              style={{
                //backgroundColor: "#fafafa",
                paddingTop: 16,
                paddingBottom: 16,
              }}
            >
              <Container>
                <Hidden smUp>
                  <Grid item xs={12} container justify="flex-start">
                    <img src={cardioLogo} style={{ height: 80 }} />
                  </Grid>
                </Hidden>
                <Grid
                  item
                  xs={12}
                  style={{
                    //paddingTop: 32,
                    marginBottom: 64,
                  }}
                >
                  <Typography variant="h6" gutterBottom style={{ fontSize: 16, color: "grey", marginBottom: 0 }}>
                    WELCOME TO
                  </Typography>
                  <Typography variant="h4" gutterBottom style={{ color: "#9933CC" }}>
                    REANIBEX TRAINING
                  </Typography>
                </Grid>
                <Grid container justify="center">
                  <Grid item xs={12} lg={8}>
                    <SignInForm />
                  </Grid>
                </Grid>
              </Container>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default withFirebase(SignInPage);

const useStyles = makeStyles((theme) => ({
  mainCard: {
    [theme.breakpoints.down("sm")]: {
      boxShadow: "none",
    },
  },
}));
